module.exports = __webpack_public_path__ + "img/yj.a0b03bda.png";